var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5181 8.08366C24.6662 7.23325 22.7101 6.63067 20.7007 6.2915C20.4446 6.73251 20.1605 7.33034 19.9607 7.79949C17.8239 7.48673 15.6528 7.48673 13.5159 7.79949C13.3162 7.33034 13.016 6.73251 12.7747 6.2915C10.7632 6.6258 8.80566 7.22856 6.95453 8.08366C3.27236 13.5178 2.27642 18.8245 2.77506 24.0589C4.93276 25.6428 7.34293 26.8502 9.90348 27.6298C10.4784 26.8531 10.9878 26.03 11.4262 25.1688C10.5858 24.8551 9.79088 24.4718 9.02148 24.016C9.2212 23.874 9.41959 23.7171 9.60457 23.5603C14.2425 25.6809 19.2651 25.6809 23.8453 23.5603C24.045 23.7171 24.23 23.874 24.4284 24.016C23.6603 24.4718 22.8641 24.8551 22.025 25.1688C22.463 26.0299 22.9719 26.8531 23.5464 27.6298C26.1079 26.8526 28.5185 25.645 30.6748 24.0589C31.2874 18.0002 29.707 12.735 26.5195 8.08366M12.0643 20.8298C10.6702 20.8298 9.53218 19.5631 9.53218 18.0136C9.53218 16.464 10.6421 15.196 12.0656 15.196C13.4731 15.196 14.6258 16.4627 14.5963 18.0136C14.5963 19.5631 13.4731 20.8298 12.0643 20.8298ZM21.4124 20.8285C20.0184 20.8285 18.879 19.5618 18.879 18.0122C18.879 16.4627 19.9889 15.1947 21.4124 15.1947C22.8199 15.1947 23.9727 16.4614 23.9445 18.0122C23.9445 19.5618 22.8346 20.8272 21.4111 20.8272",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.8d2b8cbfc78054277126f84a074f557c.svg";
export { ForwardRef as ReactComponent };